import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaFacebookF, FaInstagram, FaGoogle, FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-scroll";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
<header className="fixed top-0 left-0 w-full z-50">
  {/* Top Utility Bar - Hidden on Small Screens */}
  <div className="top-bar hidden md:flex justify-between px-8">
    <div className="flex items-center space-x-2">
      <FaPhoneAlt className="text-[#1C9BF8]" />
      <span className="tracking-wide text-white">Call us now: <a href="tel:07737389202">+44 7737 389 202</a></span>
    </div>
    <div className="social-icons flex space-x-4">
      <a href="https://www.facebook.com/people/Ramons-Supreme-Automotives/61552360670729/" target="_blank" rel="noopener noreferrer" className="social-icon"><FaFacebookF /></a>
      <a href="https://www.instagram.com/ramonsupremeauto?igsh=OWlubmtpazZ6a29o" target="_blank" rel="noopener noreferrer" className="social-icon"><FaInstagram /></a>
      <a href="https://maps.app.goo.gl/bsQDsizZAkpLFqxz6" target="_blank" rel="noopener noreferrer" className="social-icon"><FaGoogle /></a>
    </div>
  </div>

  {/* ✅ Divider Correctly Placed - Separates Top Bar & Navbar */}
  <div className="w-full h-[1px] bg-gray-700 hidden md:block"></div>

  {/* 🔵 Desktop Navbar */}
  <nav className={`glass-navbar hidden md:flex ${scrolled ? "scrolled" : ""}`}>
    <div className="navbar-container flex justify-between items-center w-full px-8">
      {/* Left Navigation */}
      <ul className="nav-left flex space-x-8 text-white text-lg font-medium">
        <li className="nav-item">
          <Link to="about" smooth={true} duration={500} offset={-100} className="cursor-pointer">
            About
          </Link>
        </li>
        <li className="nav-item">
          <Link to="services" smooth={true} duration={500} offset={-100} className="cursor-pointer">
            Services
          </Link>
        </li>
      </ul>

      {/* Center Brand Name */}
      <div className="brand-container flex flex-col items-center">
        <h1 className="brand-text gradient-text text-2xl font-bold">Ramon's</h1>
        <h2 className="text-gray-300 text-lg font-semibold flex">
          <span className="mr-1">Supreme</span> <span>Automotive</span>
        </h2>
      </div>

      {/* Right Navigation */}
      <ul className="nav-right flex space-x-8 text-white text-lg font-medium">
        <li className="nav-item">
          <Link to="gallery" smooth={true} duration={500} offset={-100} className="cursor-pointer">
            Gallery
          </Link>
        </li>
        <li className="nav-item">
          <Link to="contact" smooth={true} duration={500} offset={-100} className="cursor-pointer">
            Contact
          </Link>
        </li>
      </ul>
    </div>
  </nav>

  {/* 🍔 Mobile Navbar */}
  <nav className="md:hidden bg-[#101826] px-4 py-4 flex justify-between items-center shadow-md">
    {/* Logo - Spaced Properly */}
    <div className="text-white text-2xl font-bold pl-4">
      <h1 className="gradient-text">RSA</h1>
    </div>

    {/* Hamburger Icon */}
    <button 
      onClick={() => setMenuOpen(!menuOpen)} 
      className="text-white text-3xl focus:outline-none pr-4"
    >
      {menuOpen ? <FaTimes /> : <FaBars />}
    </button>
  </nav>

      {/* 📱 Mobile Menu (Hidden Until Opened) */}
      <div className={`fixed top-0 right-0 w-72 h-full bg-[#101826] shadow-lg transform ${menuOpen ? "translate-x-0" : "translate-x-full"} transition-transform duration-300 md:hidden flex flex-col p-6`}>
        {/* Close Button */}
        <button onClick={() => setMenuOpen(false)} className="absolute top-5 right-5 text-white text-2xl">
          <FaTimes />
        </button>

        {/* Logo */}
        <div className="text-white text-center text-3xl font-bold mt-10">
          <h1 className="gradient-text">RSA</h1>
        </div>

        {/* Mobile Menu Links */}
        <ul className="flex flex-col mt-8 space-y-6 text-white text-lg font-medium">
          <li><Link to="about" smooth={true} duration={500} offset={-80} className="cursor-pointer" onClick={() => setMenuOpen(false)}>About</Link></li>
          <li><Link to="services" smooth={true} duration={500} offset={-80} className="cursor-pointer" onClick={() => setMenuOpen(false)}>Services</Link></li>
          <li><Link to="gallery" smooth={true} duration={500} offset={-80} className="cursor-pointer" onClick={() => setMenuOpen(false)}>Gallery</Link></li>
          <li><Link to="contact" smooth={true} duration={500} offset={-80} className="cursor-pointer" onClick={() => setMenuOpen(false)}>Contact</Link></li>
        </ul>

        {/* Social Media Icons */}
        <div className="flex justify-center space-x-4 mt-auto pb-8">
          <a href="https://www.facebook.com/people/Ramons-Supreme-Automotives/61552360670729/" target="_blank" rel="noopener noreferrer" className="text-[#1C9BF8] text-2xl"><FaFacebookF /></a>
          <a href="https://www.instagram.com/ramonsupremeauto?igsh=OWlubmtpazZ6a29o" target="_blank" rel="noopener noreferrer" className="text-[#1C9BF8] text-2xl"><FaInstagram /></a>
          <a href="https://maps.app.goo.gl/bsQDsizZAkpLFqxz6" target="_blank" rel="noopener noreferrer" className="text-[#1C9BF8] text-2xl"><FaGoogle /></a>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
